import React, { FC } from 'react';

import { useLegacySearchRedirectController } from '@/controllers';
import { ExperienceErrorBoundary } from '@/components/primitive/error-boundary';
import { WithPageTitle } from '@/components/primitive/with-page-title';
import Search from '@/components/composed/search';
import { UFOExperienceContext, useRestartUFOComponentExperience } from '@/common/ufo';
import { searchViewExperience } from '@/common/ufo/experiences';

import { headerCopy } from './constants';

const SearchView: FC = () => (
  <ExperienceErrorBoundary>
    <WithPageTitle title={headerCopy.title}>
      <Search />
    </WithPageTitle>
  </ExperienceErrorBoundary>
);

const SearchViewInstrumented: typeof SearchView = props => {
  useRestartUFOComponentExperience(searchViewExperience, []);
  useLegacySearchRedirectController();

  return (
    <UFOExperienceContext.Provider value={searchViewExperience}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <SearchView {...props} />
    </UFOExperienceContext.Provider>
  );
};

export default SearchViewInstrumented;
